import React from "react";

function ListIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path
        d="M7.2 8.99995V7.19995H20.4V8.99995H7.2ZM7.2 12.9V11.1H20.4V12.9H7.2ZM7.2 16.8V15H20.4V16.8H7.2ZM4.5 8.99995C4.26667 8.99995 4.05833 8.90828 3.875 8.72495C3.69167 8.54162 3.6 8.32912 3.6 8.08745C3.6 7.84578 3.69167 7.63745 3.875 7.46245C4.05833 7.28745 4.27083 7.19995 4.5125 7.19995C4.75417 7.19995 4.9625 7.2862 5.1375 7.4587C5.3125 7.6312 5.4 7.84495 5.4 8.09995C5.4 8.33328 5.31375 8.54162 5.14125 8.72495C4.96875 8.90828 4.755 8.99995 4.5 8.99995ZM4.5 12.9C4.26667 12.9 4.05833 12.8083 3.875 12.625C3.69167 12.4416 3.6 12.2291 3.6 11.9875C3.6 11.7458 3.69167 11.5375 3.875 11.3625C4.05833 11.1875 4.27083 11.1 4.5125 11.1C4.75417 11.1 4.9625 11.1862 5.1375 11.3587C5.3125 11.5312 5.4 11.745 5.4 12C5.4 12.2333 5.31375 12.4416 5.14125 12.625C4.96875 12.8083 4.755 12.9 4.5 12.9ZM4.5 16.8C4.26667 16.8 4.05833 16.7083 3.875 16.525C3.69167 16.3416 3.6 16.1291 3.6 15.8875C3.6 15.6458 3.69167 15.4375 3.875 15.2625C4.05833 15.0875 4.27083 15 4.5125 15C4.75417 15 4.9625 15.0862 5.1375 15.2587C5.3125 15.4312 5.4 15.645 5.4 15.9C5.4 16.1333 5.31375 16.3416 5.14125 16.525C4.96875 16.7083 4.755 16.8 4.5 16.8Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ListIcon;
